import {
  FIXED,
  MOBILE,
  INSTALL_PLAN_FIXED,
  TEST_PLAN_FIXED,
  TEST_PLAN_MOBILE,
  NETWORK_IT_SECURIT_ASSESMENT_FIXED,
  SMIT_REPORT_FIXED,
  BOXI_REPORT_FIXED,
  SIA_UPLOAD_FIXED,
  CRAMER_SIA_FIXED,
  MSP_SIA_FIXED,
  OLO_NOTIFICATIONS_FIXED,
  CUSTOMER_NOTIFICATIONS_FIXED,
  GENERAL_INFORMATION_FIXED,
  GENERAL_INFORMATION_MOBILE,
  REQUIREMENTS_FIXED,
  REQUIREMENTS_MOBILE,
  SERVICE_IMPACT_ASSESSMENT_FIXED,
  SERVICE_IMPACT_ASSESSMENT_MOBILE,
  INVENTORY_FIXED,
  SMIT_CHECKS_COMPLETE_FIXED,
  DARK_FIBRE_FIXED,
  HBB_UPDATE_FIXED,
  AUDIT_FIXED,
  STATUS_UPDATE_VODAFONE_FIXDED,
  CHANGE_JUSTIFICTATION,
  INSTALL_PLAN_MOBILE,
  RISK_STATEMENT,
  CHANGE_ASSESSMENT,
  POTENTIAL_PROBLEMS,
  RISK_ASSESSMENT,
  CUSTOMER_IMPACT_ASSESMENT,
  BACKOUT_PLAN_FIXED,
  BACKOUT_PLAN_MOBILE,
  BUSINESS_DESIGN,
  DEVELOPMENT,
  TECHNICAL_DESIGN,
  BACKOUT_RESULTS_DETAILS,
  TEST_RESULTS_DETAILS,
  INSTALL_RESULTS_DETAILS,
  COMMAND_CENTRE_UPDATE,
  POST_IMPLEMENTATION_REVIEW,
  CONFIGURATION_AUDIT,
  SLM_COMPLIANCE_AUDIT,
  SLM_PROCESS_REVIEW,
  REJECTION_INFORMATION,
  EMAIL_SYSTEM,
  PAGING_SYSTEM,
  ALARM_POINT,
  TELEFONICA_UPDATE,
  CUSTOM_VALIDATION_ERRORS,
  APPROVAL_INFORMATION,
  APPROVAL_REQUEST,
  EXTERNAL_UPDATE,
  CHAT,
  VINE_UPDATE,
  PRE_CHANGE_LAB_TESTING_FIXED,
  BUSINESS_JUSTIFICATION_FIXED,
  // TECHNOLOGY_RECOVERY_PLAN,
} from 'AppSrc/core/components/forms/value-dependency-constants';


const ATTACHED_FILE = 'attached-file';
const DATE_ADDED = 'date-added';
const SUMMARY = 'summary';
const WORK_INFORMATION_ITEMS_FIELD_ID = 'work-information-items';
const WORK_INFORMATION_TYPE = 'work_items';
const REMEDY_UPLOAD = '_ACE_';

// value to indicate that a wii is locked
const WII_LOCKED_YES = 'Yes';

const NETWORK_IT_SECURITY_ASSESSMENT_NOT_REQUIRED = {
  [FIXED]: '5300',
  [MOBILE]: 'Network/IT Security assessment not required',
};

const CANCELLATION_INFORMATION = {
  [FIXED]: '22000',
  [MOBILE]: 'Cancellation Information',
};

// WII type that should be autogenerated when creating a mobile crq
const PEER_GROUP_REVIEW_TYPE_MOBILE = 'Peer Group Review';
const PEER_GROUP_REVIEW_SUMMARY = 'Peer Review for this ticket will be carried out through the ACE Portal.';

// WII type for peer rejection
const PEER_REJECTED_TYPE = {
  [FIXED]: '20600',
  [MOBILE]: 'Peer Rejected',
};

// WII type for peer approval
const PEER_APPROVED_TYPE = {
  [FIXED]: '20500',
  [MOBILE]: 'Peer Approved',
};


const fixedHumanCreatableWIT = [
  BUSINESS_JUSTIFICATION_FIXED,
  PRE_CHANGE_LAB_TESTING_FIXED,
  BACKOUT_PLAN_FIXED,
  INSTALL_PLAN_FIXED,
  TEST_PLAN_FIXED,
  SMIT_REPORT_FIXED,
  BOXI_REPORT_FIXED,
  SIA_UPLOAD_FIXED,
  CRAMER_SIA_FIXED,
  MSP_SIA_FIXED,
  OLO_NOTIFICATIONS_FIXED,
  CUSTOMER_NOTIFICATIONS_FIXED,
  GENERAL_INFORMATION_FIXED,
  REQUIREMENTS_FIXED,
  SERVICE_IMPACT_ASSESSMENT_FIXED,
  INVENTORY_FIXED,
  SMIT_CHECKS_COMPLETE_FIXED,
  DARK_FIBRE_FIXED,
  HBB_UPDATE_FIXED,
  AUDIT_FIXED,
  STATUS_UPDATE_VODAFONE_FIXDED,
];

const fixedAttachmentMandatoryWIT = [
  NETWORK_IT_SECURIT_ASSESMENT_FIXED,
  // BACKOUT_PLAN_FIXED,
  INSTALL_PLAN_FIXED,
  TEST_PLAN_FIXED,
  SMIT_REPORT_FIXED,
  INVENTORY_FIXED,
  BOXI_REPORT_FIXED,
  SIA_UPLOAD_FIXED,
  CRAMER_SIA_FIXED,
  MSP_SIA_FIXED,
  OLO_NOTIFICATIONS_FIXED,
  CUSTOMER_NOTIFICATIONS_FIXED,
  AUDIT_FIXED,
];

const mobileHumanCreatableWIT = [
  CHANGE_JUSTIFICTATION,
  INSTALL_PLAN_MOBILE,
  REQUIREMENTS_MOBILE,
  RISK_STATEMENT,
  CHANGE_ASSESSMENT,
  POTENTIAL_PROBLEMS,
  RISK_ASSESSMENT,
  SERVICE_IMPACT_ASSESSMENT_MOBILE,
  CUSTOMER_IMPACT_ASSESMENT,
  BACKOUT_PLAN_MOBILE,
  BUSINESS_DESIGN,
  DEVELOPMENT,
  TECHNICAL_DESIGN,
  TEST_PLAN_MOBILE,
  BACKOUT_RESULTS_DETAILS,
  INSTALL_RESULTS_DETAILS,
  TEST_RESULTS_DETAILS,
  COMMAND_CENTRE_UPDATE,
  POST_IMPLEMENTATION_REVIEW,
  CONFIGURATION_AUDIT,
  SLM_COMPLIANCE_AUDIT,
  SLM_PROCESS_REVIEW,
  GENERAL_INFORMATION_MOBILE,
  // TECHNOLOGY_RECOVERY_PLAN,
  REJECTION_INFORMATION,
  EMAIL_SYSTEM,
  PAGING_SYSTEM,
  ALARM_POINT,
  TELEFONICA_UPDATE,
  CUSTOM_VALIDATION_ERRORS,
  APPROVAL_INFORMATION,
  APPROVAL_REQUEST,
  EXTERNAL_UPDATE,
  CHAT,
  VINE_UPDATE,
];

const mobileAttachmentMandatoryWIT = [
  INSTALL_PLAN_MOBILE,
  // BACKOUT_PLAN_MOBILE,
  TEST_PLAN_MOBILE,
  BACKOUT_RESULTS_DETAILS,
  INSTALL_RESULTS_DETAILS,
  TEST_RESULTS_DETAILS,
  // For Technology Recovery Plan
  SERVICE_IMPACT_ASSESSMENT_MOBILE,
];

// VINE WII required
const mobileVINERefWIT = [
  TEST_RESULTS_DETAILS,
  RISK_STATEMENT,
  CHANGE_JUSTIFICTATION,
  INSTALL_PLAN_MOBILE,
];

// user can upload the multiple install plan
const noDuplicatesWorkInfoTypesMobile = [
  CHANGE_JUSTIFICTATION,
  // INSTALL_PLAN_MOBILE,
  RISK_STATEMENT,
  RISK_ASSESSMENT,
];

// Remedy creates certain autogenerated Wiis of type "General Information"
// which contain specific text. These Wiis should be ignored in the system
const generalInfoAutoGeneratedTexts = [
  'Process Flow: Standard Sans RFA',
  'This ticket was created from the external request system',
];






/*
  Test Lists:
  These lists are not explicitly used for the forms logic but they capture WITs that a user can select
  under certain circumstances and so need to be exported for the tests to work.
*/

const fixedConditionalWIT = [
  NETWORK_IT_SECURIT_ASSESMENT_FIXED,
];

export {
  ATTACHED_FILE,
  DATE_ADDED,
  SUMMARY,
  WORK_INFORMATION_ITEMS_FIELD_ID,
  WORK_INFORMATION_TYPE,
  WII_LOCKED_YES,
  NETWORK_IT_SECURITY_ASSESSMENT_NOT_REQUIRED,
  CANCELLATION_INFORMATION,
  PEER_REJECTED_TYPE,
  PEER_APPROVED_TYPE,
  PEER_GROUP_REVIEW_TYPE_MOBILE,
  PEER_GROUP_REVIEW_SUMMARY,
  fixedHumanCreatableWIT,
  fixedAttachmentMandatoryWIT,
  mobileHumanCreatableWIT,
  mobileAttachmentMandatoryWIT,
  mobileVINERefWIT,
  noDuplicatesWorkInfoTypesMobile,
  generalInfoAutoGeneratedTexts,
  /* test lists */
  fixedConditionalWIT,
  REMEDY_UPLOAD,
};


